export default __webpack_public_path__ + "static/media/img1.f3b98161.png";